// extracted by mini-css-extract-plugin
module.exports = {"pricing":"styles_pricing__9MrXZ","priceUsd":"styles_priceUsd__OmXr_","priceEth":"styles_priceEth__VCG3J"};